import { useFormContext } from 'react-hook-form';
import { useTranslation } from 'react-i18next';

import { Field, FieldError, FieldLabel } from '@/components/shadcn/field';
import { Input } from '@/components/shadcn/input';

import type { CreatePartyValues } from './types';
import useRequiredByCrm from './useRequiredByCrm';

export default function NLNameFields() {
  const { t } = useTranslation();

  const {
    register,
    formState: { errors },
  } = useFormContext<CreatePartyValues>();

  const requiredByCrm = useRequiredByCrm();

  const initialsLabel = t('PARTY_CREATE_INLINE_INITIALS_LABEL');
  const firstNameLabel = t('PARTY_CREATE_INLINE_FIRST_NAME_LABEL');
  const lastNameLabel = t('PARTY_CREATE_INLINE_LAST_NAME_LABEL');

  const initials = requiredByCrm('initials', initialsLabel);
  const firstName = requiredByCrm('firstName', firstNameLabel);

  return (
    <>
      <Field data-invalid={errors.initials ? true : undefined}>
        <FieldLabel htmlFor="initials">
          {initialsLabel}
          {initials.isRequired && ' *'}
        </FieldLabel>

        <Input
          id="initials"
          {...register('initials', { validate: initials.validate })}
        />

        <FieldError errors={errors.initials ? [errors.initials] : undefined} />
      </Field>

      <Field data-invalid={errors.firstName ? true : undefined}>
        <FieldLabel htmlFor="firstName">
          {firstNameLabel}
          {firstName.isRequired && ' *'}
        </FieldLabel>

        <Input
          id="firstName"
          {...register('firstName', { validate: firstName.validate })}
        />

        <FieldError
          errors={errors.firstName ? [errors.firstName] : undefined}
        />
      </Field>

      <Field data-invalid={errors.lastName ? true : undefined}>
        <FieldLabel htmlFor="lastName">
          {lastNameLabel}
          {' *'}
        </FieldLabel>

        <Input
          id="lastName"
          {...register('lastName', {
            required: t('PARTY_CREATE_INLINE_REQUIRED'),
          })}
        />

        <FieldError errors={errors.lastName ? [errors.lastName] : undefined} />
      </Field>
    </>
  );
}
